export const APP_KEY = "ICP";

export const SIGN_VALUES_P2 = {
  DEFAULT: 0x00,
  STAKE_TX: 0x01,
};

export const PKLEN = 65;
export const ADDRLEN = 32;
export const PRINCIPAL_LEN = 29;
export const PREHASH_LEN = 43;
export const SIGRSLEN = 64;
